function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M4.5 5H8M15.5 5H12M12 5V4H8V5M12 5H8",
  stroke: "currentColor",
  strokeWidth: 1.5
});

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M5.75 15V7.25H14.25V15C14.25 15.6904 13.6904 16.25 13 16.25H7C6.30964 16.25 5.75 15.6904 5.75 15Z",
  stroke: "currentColor",
  strokeWidth: 1.5
});

var SvgComponent = function SvgComponent(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none"
  }, props), _ref, _ref2);
};

export default __webpack_public_path__ + "static/media/trash.cd0a54da.svg";
export { SvgComponent as ReactComponent };